<template>
    <a-card :bordered="false">
      <a-form-item><a @click="routeBack">&lt;&lt; 返回</a></a-form-item>
      <detail-list title="物料详情" v-if="mdl">
        <detail-list-item term="物料ID">{{ mdl.materielId }}</detail-list-item>
        <detail-list-item term="物料名称">{{ mdl.materielName }}</detail-list-item>
        <detail-list-item term="物料编码">{{ mdl.materielCode }}</detail-list-item>
        <detail-list-item term="物料类型">{{ mdl.materielType }}</detail-list-item>
        <detail-list-item term="装卸货状态">{{ mdl.matStatus }}</detail-list-item>
        <detail-list-item term="装卸货时间">{{ mdl.loadTime | formatDate}}</detail-list-item>
        <detail-list-item term="装卸货地点">{{ mdl.loadId }}</detail-list-item>
        <detail-list-item term="装卸货序号">{{ mdl.loadNumber }}</detail-list-item>
      </detail-list>
    </a-card>
  </page-view>
</template>

<script>
import DetailList from '@/components/tools/DetailList'
import Moment from 'moment'
import { getNameByTypeAndValue } from '@/api/sys'
import storage from "@/utils/storage"

const DetailListItem = DetailList.Item

export default {
  components: {
    DetailList,
    DetailListItem
  },
  data () {
    return {
      mdl: null
    }
  },
  mounted () {
    this.initData()
  },
  filters: {
    formatDate (value) {
      if (!value) return ""
      return Moment(value).format('YYYY-MM-DD HH:mm:ss')
    }
  },
  methods: {
    routeBack(){
      localStorage.setItem('goback', "true");
      this.$router.back(-1)
    },
    initData () {
      let materielCache = storage.fetch("cache-MaterielDetail");
      if (materielCache){
          this.mdl = JSON.parse(materielCache);
      } 
      // this.mdl = JSON.parse(this.$route.query.datas)
      this.getNameByTypeAndValue(this.config.TYPE_CODE.MATERIEL_TYPE,this.mdl.materielType, 'materielType' )
      this.getNameByTypeAndValue(this.config.TYPE_CODE.MATERIEL_STATUS,this.mdl.matStatus,'matStatus' )
    },

    getNameByTypeAndValue(type, value, column) { 
      new Promise(resolve => {
        const data = getNameByTypeAndValue({ "type":type, "value":value}).then(res => { return res.data })
        resolve(data)
      }).then(res => {
        this.mdl[column] = res
      })
    },


  }
}
</script>



